<template>
  <div @keydown.up="handleKeyUp()"
       @keydown.down="handleKeyDown()"
       @keydown.enter="handlerKeyEnter()">
    <label 
      :for="`ato_${ _uid }`"
      class="label"
      :class="name == 'uf-label' ? 'uf-label' : ''">{{ label }}
      <span v-if="required"
            class="text-danger">{{ required ? ' *' : '' }}</span>
    </label>
    <div ref="customSelect"
         :class="['custom-select', { 'custom-select-disabled': disabled }]"
         @click="toggleDropdown">
      <div class="selected-option">
        <div class="selected-option"
             @click="toggleDropdown"
             @mousedown="stopClickPropagation">
          <span v-if="selectedOption"
                :class="disabled ? 'text-selected-disabled' : ''"
                @click="toggleDropdown">{{ truncatedSelectedOption }}</span>
        </div>
        <span v-if="selectedOption && !disabled"
              class="close-icon"
              @click="selectOption(null)">&times;</span>
        <input v-if="!selectedOption && !disabled"
               v-model="searchText"
               type="text"
               class="search-input"
               placeholder="Digite para buscar...">
      </div>
      <ul v-if="isDropdownOpen"
          ref="listContainer" 
          class="options">
        <li v-for="(option, index) in filteredOptions"
            ref="listItem"
            :key="index"
            :class="{ 'selected-item': index === selectedItemIndex }"
            @mouseover="handlerMouseHover(index)"
            @click="selectOption(option)">
          {{ option.text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CustomSelect',
    props: {
      name: { type: String, required: true }, // Identificador único para o input 
      label: {type: String, default: ''},
      options: { type: Array,  default: () => { return [] }, required: true }, // Arrai de opções no formato {text: String, value: Any, index: Number?}
      disabled: { type: Boolean, default: false },
      selected: { type: [String, Number, Boolean], default: false }, // Valor inicial
      propMaxDisplayLength: {type: Number, default: 0},
      formErros: {type: Array, default: null}, // Array que armazena os erros do formulário (opcional)
      required: {type: Boolean, default: false}, // Boleano que determina se o input é obrigatório (opcional)
    },
    data () {
      return {
        selectedOption: null,
        selectedValue: null,
        isDropdownOpen: false,
        maxDisplayLength: 33,
        searchText: '',
        filteredOptions: null,
        selectedItemIndex: 0,
        maxHeight: null
      }
    },
    computed: {
      truncatedSelectedOption () {
        if (this.selectedOption && this.selectedOption.length > this.maxDisplayLength) {
          return `${this.selectedOption.slice(0, this.maxDisplayLength)}...` // Adicione "..." se for truncado
        }
        
        return this.selectedOption
      },
    },
    watch: {
      options () {
        this.filteredOptions = this.options
      },
      filteredOptions () {
        if (this.filteredOptions.length) this.updateListItemHeights()
      },
      selected () {
        if (this.selected) {
          this.selectedOption = this.selected
        } else this.selectedOption = false
      },
      propMaxDisplayLength () {
        if (this.propMaxDisplayLength) this.maxDisplayLength = this.propMaxDisplayLength
      },
      searchText () {
        this.filterOptions()
      }
    },
    created () {
      if (this.selected) {
        this.selectedOption = this.selected
      } else this.selectedOption = false

      this.filteredOptions = this.options
      this.updateListItemHeights()
      this.init()
    },
    mounted () {
      document.addEventListener('click', this.closeDropdownOnClickOutside)
    },
    beforeDestroy () {
      document.removeEventListener('click', this.closeDropdownOnClickOutside)
    },
    methods: {
      init () {
        if (this.selected && this.required) {
          this.value = this.initialValue
          this.updateErrorForm(false)
        }
        
        if (this.required &&
          !this.selected &&
          this.formErros) {
          this.updateErrorForm(true)
        } // Adiciona o input ao array de erros para validação inicial no componente pai
      },
      toggleDropdown () { // Controla exibição da lista de opções
        if (!this.disabled) {
          return this.isDropdownOpen = !this.isDropdownOpen
        }
        this.isDropdownOpen = !this.isDropdownOpen
      },
      selectOption (option) { // Define opção selecionada e e emit para componente proncipal
        if (!this.disabled) {
          this.isDropdownOpen = !this.isDropdownOpen          
        }
        if (!option) {
          this.selectedOption = null
          this.searchText = ''
          this.$emit('setSelectValue', null)
          if (this.required) {
            this.updateErrorForm(true)
          }
          return
        }
        this.selectedOption = option.text
        this.isDropdownOpen = false
        this.updateErrorForm(false)
        this.$emit('setSelectValue', option)
      },
      closeDropdownOnClickOutside (event) { // fecha lista de opção ao clicar fora
        if (
          this.isDropdownOpen &&
          !this.$refs.customSelect.contains(event.target)
        ) {
          this.isDropdownOpen = false
        }
      },
      stopClickPropagation (event) { // Impede a propagação do evento de clique para que não feche a lista imediatamente.
        event.stopPropagation()
      },
      filterOptions () {
        if (this.searchText.length > 0) this.isDropdownOpen = true
        else this.isDropdownOpen = false

        const query = this.searchText.toLowerCase()
        this.filteredOptions = this.options.filter(option =>
          option.text.toLowerCase().includes(query)
        )
      },
      handleKeyDown () {
        this.updateListItemHeights()
        if (!this.isDropdownOpen) this.isDropdownOpen = true
        if (this.selectedItemIndex < this.filteredOptions.length - 1) {
          this.selectedItemIndex++
          const pxItem = this.filteredOptions[this.selectedItemIndex]?.height
          this.scrollList(pxItem, 'down')
        }
      },
      handleKeyUp () {
        if (!this.isDropdownOpen) return
        if (this.selectedItemIndex > 0) {
          this.selectedItemIndex--
          const pxItem = this.filteredOptions[this.selectedItemIndex]?.height
          this.scrollList(pxItem, 'up')
        }
      },
      handlerKeyEnter () {
        this.selectOption(this.filteredOptions[this.selectedItemIndex])
      },
      handlerMouseHover (index) {
        this.selectedItemIndex = index
      },
      scrollList (itemHeight, type) {
        let totalHeight = 0
        for (let i = 0; i <= this.selectedItemIndex; i++) totalHeight += itemHeight + 10
        if (totalHeight < 400 && type === 'down') return   
        
        const container = this.$refs.listContainer
        if (container) {  
          if (type === 'up') return container.scrollTop -= itemHeight - 20
          if (type === 'down') return container.scrollTop += itemHeight + 20
        }
      },
      updateListItemHeights () {
        if (!this.filteredOptions.length) return
        // Obtenha as alturas dos elementos li dinamicamente
        const listItems = this.$refs.listItem
        let heightTotalItens = 0

        if (listItems && listItems.length > 0) {  
          listItems.forEach((item, index,) => {
            const itemHeight = item.offsetHeight
            heightTotalItens += itemHeight + 10 // 10 é o paddind de li - itens da lista ul
            this.filteredOptions[index] ? this.filteredOptions[index].height = itemHeight  : null     
   
          })
        }
        return heightTotalItens
      },
      updateErrorForm (add) {
        if (!this.formErros) return
        const arr = this.formErros
        const erroAlredyExist = arr.includes(this.name)
        if (add && !erroAlredyExist) {
          arr.push(this.name)
        } else if (!add && erroAlredyExist) {
          const index = arr.indexOf(this.name)
          arr.splice(index, 1)
        }
        this.$emit('setError', arr)
      },
    },
  }
</script>

<style scoped>
.custom-select {
  position: relative;
  width: 100%; 
}

.search-input {
  width: 100%;
  border: none;
  outline: none;
  background: none;
  box-shadow: none;
  appearance: none;
}
.selected-option {
  padding: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.selected-option i {
  margin-left: 5px;
}

.options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  background-color: white;
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: auto;
  max-height: 400px; /* Personalize conforme necessário */
  overflow-y: auto;
  z-index: 1000;
}

.options li {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}

.close-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: #ededed; /* Cor de fundo do ícone de fechar */
  color: black; /* Cor do ícone de fechar */
  border-radius: 50%; /* Bordas arredondadas para criar um fundo circular */
  width: 24px; /* Largura do ícone */
  height: 24px; /* Altura do ícone */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px; /* Tamanho do ícone */
}
.custom-select-disabled {
  background-color: #e9ecef;
  pointer-events: none; /* Impede a interação do usuário com o componente */
  cursor: not-allowed; /* Altera o cursor para 'não permitido' */
}

.text-selected-disabled {
  color: #6c757e;
}

.selected-item {
  background-color: #0679BB;
  color: white;
}

.selected-item:hover {
  background-color: #0679BB;
  color: white;
}

.uf-label {
    padding-bottom: 0px
  }
</style>


<!-- 
// Documentação
1. Import e registre o componenteem seu componente Vue principal.

<CustomSelect
      :options="selectOptions" - Opções para ser exibidas, formato = Object { value: objeto completo, text: string a ser exibida ao listar }
      :disabled="isDisabled" - Controla se é possivel editar ou não o input
      :selected="texto/resultado a ser exibido do item já selecionado" - caso seja alterado será recebido em handleSelectChange o value e text para se atualizar o objeto principal
      :prop-max-display-length="33" - numero de caracterers a ser exibido quando item é selecionado
      @input="handleSelectChange" - User para atualizar o valor no componente principal
    >
2. Metodos
  - toggleDropdown: Alterna a exibição do dropdown.
   - selectOption(option): Seleciona uma opção específica passando o objeto de opção como argumento.

3. Lifecycle Hooks
  - mounted: Registra um evento de clique no documento para fechar o dropdown quando clicar fora do componente.
  - beforeDestroy: Remove o evento de clique no documento antes de destruir o componente para evitar vazamentos de memória, propagação do click

/> -->